import * as React from "react";

const ListSort: React.FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M4.16675 5.83333C4.16675 5.3731 4.53984 5 5.00008 5H15.8334C16.2937 5 16.6667 5.3731 16.6667 5.83333C16.6667 6.29357 16.2937 6.66667 15.8334 6.66667H5.00008C4.53984 6.66667 4.16675 6.29357 4.16675 5.83333ZM4.16675 10C4.16675 9.53976 4.53984 9.16667 5.00008 9.16667H13.3334C13.7937 9.16667 14.1667 9.53976 14.1667 10C14.1667 10.4602 13.7937 10.8333 13.3334 10.8333H5.00008C4.53984 10.8333 4.16675 10.4602 4.16675 10ZM5.00008 13.3333C4.53984 13.3333 4.16675 13.7064 4.16675 14.1667C4.16675 14.6269 4.53984 15 5.00008 15H10.8334C11.2937 15 11.6667 14.6269 11.6667 14.1667C11.6667 13.7064 11.2937 13.3333 10.8334 13.3333H5.00008Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(ListSort);
